import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_AUTO_FREE_PROMOTIONS_ROLLOUT = defineFcm('auto_free_promotions_rollout')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				traffic_percentage: { type: 'number' },
				user_safelist: {
					type: 'array',
					shape: { type: 'number' },
					optional: true,
				},
				user_blocklist: {
					type: 'array',
					shape: { type: 'number' },
					optional: true,
				},
			},
		}),
	)
	.withDefault({
		traffic_percentage: 0,
		user_safelist: [],
		user_blocklist: [],
	})
	.toConfig({
		owner: 'squad-starfish',
		scope: 'promotion-service',
		context: 'Auto Free Promotions',
		description: 'Roll out auto free promotions on petition creation by country and percentage.',
		import: false,
		template: {
			traffic_percentage: 20,
			user_safelist: [123, 456],
			user_blocklist: [789],
		},
		deprecated: 'No references found. Safe to delete after 2026-09-01.',
	});
